import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	isQuizzModalOpen: false,
	quizzFormData: {}
};

const quizzesSlice = createSlice({
	name: "quizzes",
	initialState,
	reducers: {
		toggleQuizzModal: (state, action) => {
			const isQuizzModalOpen = action.payload;
			state.isQuizzModalOpen = isQuizzModalOpen;
			if (!isQuizzModalOpen) {
				state.quizzFormData = {}
			}
		},
		getQuizzFormData: (state, action) => {
			state.quizzFormData = action.payload;
		}
	},
});

export const { toggleQuizzModal, getQuizzFormData } = quizzesSlice.actions;
export default quizzesSlice.reducer;
